import React from 'react';
import useActions from 'hooks/useActions';
import ANALYTICS from 'constants/analytics';
import { checkinStart } from 'actions/checkin';
import { MODAL, MODAL_THEMES, MODAL_BUTTON_TYPES } from 'constants';
import CHECKIN from 'constants/checkin';
import { i18n } from 'utils/i18n';
import { analyticsInteraction, analyticsPrepareKey } from 'utils/analytics';
import Modal from 'components/Modal';
import { ModalFooter } from 'components/Modal/ModalFooter';
import { startAdditionalDriverFlow } from 'actions/reservation/startAdditionalDriverFlow';

const AdditionalDriverOciRequestModal = ({ isFoundRental }) => {
  const checkinOrigin = isFoundRental
    ? CHECKIN.CHECKIN_ORIGIN.RESERVATION_DETAILS
    : CHECKIN.CHECKIN_ORIGIN.CONFIRMATION;

  const startOciCheckin = useActions(() => checkinStart({ origin: checkinOrigin }));
  const additionalDriverFlowStart = useActions(startAdditionalDriverFlow);

  return (
    <Modal
      modalKey={MODAL.ADDITIONAL_DRIVER_OCI_REQUEST_MODAL}
      header={i18n('additional_driver_oci_request_modal_header')}
      theme={MODAL_THEMES.WHITE}
    >
      {() => (
        <>
          <p id={`${MODAL.ADDITIONAL_DRIVER_OCI_REQUEST_MODAL}_desc`} className='modal-themed__paragraph'>
            {i18n('additional_driver_oci_request_modal_copy')}
          </p>
          <ModalFooter
            buttons={[
              {
                type: MODAL_BUTTON_TYPES.DECLINE,
                label: i18n('additional_driver_oci_request_modal_decline'),
                largeButton: true,
                handler: additionalDriverFlowStart,
                analyticsHandler: () =>
                  analyticsInteraction(
                    ANALYTICS.MODAL,
                    analyticsPrepareKey(MODAL.ADDITIONAL_DRIVER_OCI_REQUEST_MODAL),
                    i18n('additional_driver_oci_request_modal_decline')
                  ),
              },
              {
                type: MODAL_BUTTON_TYPES.ACCEPT,
                label: i18n('additional_driver_oci_request_modal_accept'),
                largeButton: true,
                handler: startOciCheckin,
                analyticsHandler: () =>
                  analyticsInteraction(
                    ANALYTICS.MODAL,
                    analyticsPrepareKey(MODAL.ADDITIONAL_DRIVER_OCI_REQUEST_MODAL),
                    i18n('additional_driver_oci_request_modal_accept')
                  ),
              },
            ]}
          />
        </>
      )}
    </Modal>
  );
};

export default AdditionalDriverOciRequestModal;
